import { render, staticRenderFns } from "./noteable_note.vue?vue&type=template&id=4830d03f&vue3"
import script from "./noteable_note.vue?vue&type=script&lang=js&vue3"
export * from "./noteable_note.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports